import React, {useState} from "react";
import { Route, Switch } from "react-router-dom";
import Confirmation from "./components/Confirmation";
import Error404 from "./components/Error404";
import PasswordRecovery from "./components/PasswordRecovery";
import SelectVerificationOption from "./components/SelectVerificationOption";
import SetPassword from "./components/SetPassword";
import StyleGuide from "./components/StyleGuide";
import Success from "./components/Success";
import TellUsWhoYouAre from "./components/TellUsWhoYouAre";
import Validate from "./components/Validate";
import Welcome from "./components/Welcome";
import "./styles/App.scss";
import PolicyNotice from "./components/PolicyNotice";
import APIService from "./services/APIService";
import MockAPIService from "./test/services/MockAPIService.js";
import Header from "./components/Header";

export const App = (props) => {
	const [user, setUser] = useState(props.user || {});
	const [token, setToken] = useState(null);
	const [pwReset, setPwReset] = useState(false);
	const [routeToWelcome, setRouteToWelcome] = useState(false);

	// Setup for API Service 
	if (props.user) {	MockAPIService.set_user(user) } else { MockAPIService.set_default_user() };
	const theAPI = props.useMockApiService || process.env.REACT_APP_MOCK_API ? MockAPIService : APIService;

	return (
		<>
			<Header apiService={theAPI}/>
			<Switch>
				<Route path="/" exact	render={() => <PasswordRecovery setPwReset={setPwReset} apiService={theAPI} />} />
				<Route path="/welcome/:token" render={() => <Validate setUser={setUser} setToken={setToken} setRouteToWelcome={setRouteToWelcome} apiService={theAPI} />} />
				<Route path="/telluswhoyouare"	render={() => <TellUsWhoYouAre pwReset={pwReset} setUser={setUser} apiService={theAPI} />} />
				<Route path="/selectverificationoption" exact render={() => <SelectVerificationOption user={user} setUser={setUser} setToken={setToken} routeToWelcome={routeToWelcome} apiService={theAPI} pwReset={pwReset} />} />
				<Route path="/welcome" exact render={() => <Welcome user={user} apiService={theAPI}/>} />
				<Route path="/setpassword" exact render={() => <SetPassword user={user} token={token} pwReset={pwReset} apiService={theAPI}/>} />
				<Route path="/confirmation" exact render={() => <Confirmation user={user} apiService={theAPI}/>} />
				<Route path="/success" exact render={() => <Success user={user} apiService={theAPI}/>} />
				<Route path="/styleguide" exact render={() => <StyleGuide apiService={theAPI}/>} />
				<Route path="/policynotice" exact render={() => <PolicyNotice/>} />
				<Route path="/*" render={() => <Error404 apiService={theAPI}/>} />
			</Switch>
		</>
	)
}

export default App;
